import { ModalWrapper } from "src/utils/fw"

export default {
    background: "https://assets.swoogo.com/uploads/full/2722594-64a70079553e0.png",
    name: "on-demand",
    links: [
            {
                label: "Keynotes on Demand",
                height: "42.7%",
                left: "18.9%",
                top: "28.8%",
                width: "13.1%",
                href: "/keynotes",
            },
            {
                label: "Breakouts on Demand",
                height: "35.5%",
                left: "49.3%",
                top: "31.9%",
                width: "10.7%",
                href: new Date() > new Date("2023-10-23 08:00:00+0200") ? "/breakout" : undefined,
                modal: new Date() > new Date("2023-10-23 08:00:00+0200") ? undefined : <ModalWrapper wrapperStyle={{background: "rgb(59, 80, 206)"}}>
			    <h1 style={{color: "white"}}>Breakout sessions will be released each day at 08:00 CEST, beginning on Monday 23 October.</h1>
		       </ModalWrapper>,
		            modalOverrides: {
			        dismissHTML: "X",
			        dismissStyle: {
				    color: "white",
				    "font-size": "20px"
			        }
		        }
            },
            {
                label: "Congress Back in Time",
                width: "9.8%",
                height: "28.1%",
                left: "83.7%",
                top: "69.1%",
                href: "https://www.isflive.org/s/congress/back-in-time",
                target: "blank"
            },
    ].map(it => {
        if (new Date() < new Date("2023-10-22 08:00:00+0200")) {
            return {
                ...it,
                href: undefined,
                modal: new Date() > new Date("2023-10-23 08:00:00+0200") ? undefined : <ModalWrapper wrapperStyle={{background: "rgb(59, 80, 206)"}}>
                    <h1 style={{color: "white"}}>On-Demand sessions will be released each day at 08:00 CEST, beginning on Monday 23 October.</h1>
                </ModalWrapper>,
                modalOverrides: {
                    dismissHTML: "X",
                    dismissStyle: {
                        color: "white",
                        "font-size": "20px"
                    }
                }
            }
        }
        return it
    })
}